module.exports = __webpack_public_path__ + "static/media/the-telegraph.1780f4da.png";